import RideauMetallique from 'assets/img/rideau-metallique.png';
import StoreBanne from 'assets/img/store-banne.png';
import VoletRoulant from 'assets/img/volet-roulant.png';
import formInputsTypes from '../simulatorConstant';

import MainOuvreDataVolet from '../voletRoulant/mainOeuvre';
import MainOuvreDataRideau from '../rideauMetallique/mainOeuvre';
import MainOuvreDataStore from '../Storebanne/mainOeuvre';
import MainOuvreDataPorte from '../PorteGarage/mainOeuvre';
import MainOuvreDataPortail from '../Portail/mainOeuvre';

const MainOuvreData = {
	id: 'MO',
	type: formInputsTypes?.RADIO_INPUT,
	label: "Main d'œuvre",
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	options: [
		{
			id: 'VR1',
			label: 'Volet Roulant',
			value: 'VR1',
			imageUrl: VoletRoulant,
			nextStep: MainOuvreDataVolet,
			lst_price: 0,
		},
		{
			id: 'SB1',
			label: 'Store banne',
			value: 'SB1',
			imageUrl: StoreBanne,
			nextStep: MainOuvreDataStore,
			lst_price: 0,
		},
		{
			id: 'RM1',
			label: 'Rideau métallique',
			value: 'RM',
			imageUrl: RideauMetallique,
			nextStep: MainOuvreDataRideau,
			lst_price: 0,
		},
		{
			id: 'RM41',
			label: 'Porte de garage',
			value: 'pg',
			nextStep: MainOuvreDataPorte,
			lst_price: 0,
		},
		{
			id: 'RM3',
			label: 'Portail électrique',
			value: 'pe',
			nextStep: MainOuvreDataPortail,
			lst_price: 0,
		},
	],
};

export default MainOuvreData;
